import { createContext, useContext } from "react";
import { CoachProfileModel } from "app/models/scheduling/CoachProfileModel";

export type SelectedCoachContextType = {
  selectedCoachId: string | null;
  setSelectedCoachId: (id: string) => void;
  selectedCoach: CoachProfileModel | null;
  coaches: CoachProfileModel[];
  canSelectCoach: boolean;
};

export const SelectedCoachContext = createContext<SelectedCoachContextType>({
  selectedCoachId: null,
  setSelectedCoachId: () => {},
  selectedCoach: null,
  coaches: [],
  canSelectCoach: false,
});

export const useSelectedCoach = () => useContext(SelectedCoachContext);
